import Backbone from 'backbone'
import template from './welcome.hbs'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import alerts from 'scoreboard/components/alerts'
import alertHelper from 'scoreboard/alerts/alert-helper'
import AlertList from './alerts/alert-list'
import DisplayHeader from 'scoreboard/components/display-header'
import WelcomeMessage from './welcome-message'
import license from 'scoreboard/components/license'
import highlight from 'scoreboard/components/highlight'
import user from 'scoreboard/components/user'
import appDisplay from 'scoreboard/components/app-display'
import WelcomeSupportForm from './welcome-support-form'
import scrollContainer from 'scoreboard/components/scroll-container'
import diagnostics from 'scoreboard/components/diagnostics'
import HomeNav from './home-nav'
import { isV6 } from 'scoreboard/components/version'

var Welcome = Backbone.View.extend({

	// this.options.data is the WelcomeResponse from GET api/home/welcome in
	// HomeController

	className: 'home welcome alerts display-layout table-hack',

	events: {
		'click .contact-us': 'supportForm'
	},

	initialize: function(options) {
		this.options = options

		var alertsData = (data) => _.extend({ alerts: data.unread }, alertHelper.dataByIdByDomainType(data), { unread: true })
		this.unreadAlerts = new AlertList({
			data: alertsData(this.options.data.alerts)
		})
		alerts.listenForPushNotification(this, newData => {
			this.unreadAlerts = new AlertList({
				data: alertsData(newData)
			})
			this.renderAlerts()
		}, 4)
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('home.welcome'),
			mobileGearHidden: true
		}).render().el, template(this.context()))

		this.homeNav = new HomeNav({
			section: 'welcome'
		})
		this.$('.home-nav-container').append(this.homeNav.el)
		this.homeNav.render()

		// If the welcome message option is turned on,
		// only show the welcome message panel if there is a welcome message, image, or video to show,
		// or if the user is the app admin (so they can add a message)
		if (this.options.data.showMessage &&
			(_.trim(this.options.data.message) || permissions.appAdmin() ||
			this.options.data.imageId || this.options.data.videoId)) {
			this._welcomeMessage = new WelcomeMessage({
				message: this.options.data.message,
				imageId: this.options.data.imageId,
				youTubeVideos: this.options.data.youTubeVideos,
				lastLogin: this.options.data.lastLogin,
				scrollEl: scrollContainer(this.el)
			})

			this.$('.welcome-message')
				.append(this._welcomeMessage.el)
				.removeClass('is-not-displayed')
			this._welcomeMessage.render()
			this.on('resize',() => this._welcomeMessage.trigger('resize'))
		}

		this.renderAlerts()
		this._setupListeners()
		this._resizeAlertLists()
		this.secure()

		if (!diagnostics.emailEnabled) {
			this.$('.panel.support').addClass('is-not-displayed')
		}

		return this
	},

	_setupListeners() {
		this.on('resize', () => this._resizeAlertLists())
	},

	_resizeAlertLists() {
		this.unreadAlerts.adjustOverflow()
	},

	renderAlerts: function() {
		if (!alerts.unreadAlerts) {
			this.$('.unread-total').hide()
			this.$('.show-all-alerts').remove()
		} else {
			this.$('.alert-list').replaceWith(this.unreadAlerts.el)
			this.unreadAlerts.render()
			this.$('.unread-total').text(alerts.unreadAlerts)
			this.$('.alert-list-empty').remove()
		}
		this.unreadAlerts.disableAlertActions()
	},

	context: function() {
		var d = this.options.data

		_.defaults(d, {
			'numUpdateableMetrics' : 0,
			'numTasks' : 0,
			'numOwnedMetrics' : 0
		})
		return {
			numTasksMsg: highlight(i18n.countMessage('initiatives.tasks.number', d.numTasks)),
			numOwnedMetricsMsg: highlight(i18n.countMessage('scorecards.node.metric.number', d.numOwnedMetrics)),
			numUpdateableMetricsMsg: highlight(i18n.countMessage('scorecards.node.metric.number', d.numUpdateableMetrics))
		}
	},

	secure: function() {
		let isActiveViewer = permissions.activeViewer()
		if (permissions.readOnly() && !isActiveViewer) {
			// Remove the .responsibilities section
			this.$('.responsibilities').remove()
		}
		if (permissions.readOnly()) {
			this.$('.responsibilities .metrics-i-update').remove()
		}
		if (permissions.readOnly() || !license.initiatives) {
			this.$('.responsibilities .my-tasks').remove()
		}
		if (!license.scorecards) {
			this.$('.responsibilities .metrics-i-own').remove()
		}
		if (user.model.get('publicReadOnlyUser')) {
			this.$('.new-alerts').remove()
			// Replace grid-w-6 with grid-w-12 to make support panel full width
			this.$('.right-column').toggleClass('grid-w-6 grid-w-12')
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		alerts.stopListeningForPushNotification(this)
		_.invokeMap([this._welcomeMessage, this.unreadAlerts], 'remove')
	},

	supportForm: function() {
		appDisplay.dialog(new WelcomeSupportForm())
	}
})

export default Welcome

Welcome.__filename__ = 'home/welcome.js'
